import { useRbacRoles } from "services/rbac/useRbacRoles";

import { AssignStep } from "../AssignStep/AssignStep";
import { EditDatabasePrivilegesStep } from "../EditDatabasePrivilegesStep";
import { EditPrivilegesStep } from "../EditPrivilegesStep";
import { RolesWizardStep } from "../types";
import { NameStep, Props } from "./NameStep";
import { PrivilegesStep } from "./PrivilegesStep";

const RoleNameStep = (props: Props) => {
  const roles = useRbacRoles();

  return (
    <NameStep
      {...props}
      roles={roles}
    />
  );
};

export const stepsByType = {
  [RolesWizardStep.name]: RoleNameStep,
  [RolesWizardStep.privileges]: PrivilegesStep,
  [RolesWizardStep.assign]: AssignStep,
  [RolesWizardStep.editDatabasePrivileges]: EditDatabasePrivilegesStep,
  [RolesWizardStep.editPrivileges]: EditPrivilegesStep,
};
